import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  CardGroup,
  Table,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { TiPrinter } from "react-icons/ti";
import { toast } from "react-toastify";
import {
  getAllAgents,
  resetAgentList,
  getAgentById,
  deleteAgent,
  resetAgentDelete,
  resetAgentCreate,
} from "../features/agent/agentSlice";
import { logout } from "../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

const AgentList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [allAgents, setAllAgents] = useState([]);

  const [searchByName, setSearchByName] = useState("");

  const [searchByPhone, setSearchByPhone] = useState("");

  //user Selector
  const { userInfo } = useSelector((state) => state.user);

  const {
    agents,
    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,

    isDeleteError,
    isDeleteLoading,
    isDeleteSuccess,
    deleteErrorMessage,
  } = useSelector((state) => state.agent);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("agentList") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    if (isListError) {
      toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      const filteredAgents = agents
        .filter((agent) => {
          if (
            searchByName === "" ||
            agent.fullName.toLowerCase().includes(searchByName.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        })
        .filter((agent) => {
          if (
            searchByPhone === "" ||
            agent.phone.toLowerCase().includes(searchByPhone.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        });
      setAllAgents(filteredAgents);
    } else {
      dispatch(getAllAgents());
    }
  }, [
    dispatch,
    isListError,
    isListSuccess,
    // listErrorMessage,
    searchByName,
    searchByPhone,
    agents,
  ]);

  useEffect(() => {
    if (isDeleteError) {
      toast.error(deleteErrorMessage, { position: "top-center" });
    } else if (isDeleteSuccess) {
      toast.success("Agent Deleted Successfully", { position: "top-center" });
    }
  }, [isDeleteError, isDeleteSuccess, deleteErrorMessage]);

  useEffect(() => {
    return () => {
      dispatch(resetAgentList());
      dispatch(resetAgentDelete());
    };
  }, []);

  const handleDelete = (id) => {
    if (
      window.confirm(
        "Are You Sure You Want to Delete This Agent? This Action Can't Be Undone!"
      )
    ) {
      dispatch(deleteAgent(id));
      dispatch(resetAgentList());
    }
  };

  return (
    <Container fluid className="my-4">
      {/* <h2 style={{ fontWeight: "bold " }} className="mb-3 text-center">
        All Agents List
      </h2> */}
      <Row className="mb-4">
        <Card
          className="rounded-4 border"
          style={{ backgroundColor: "#e6edf1" }}
        >
          <h2 className="my-3 text-dark text-center fw-bold">
            All <span style={{ color: "#5c91dc" }}>Agents</span> List
          </h2>
        </Card>
      </Row>

      <Row>
        {/* Search Options */}
        <CardGroup className="mb-5 p-0">
          <Card>
            <Card.Header
              className="text-center fw-bold text-black"
              style={{ backgroundColor: "#74a2e3" }}
              as="h6"
            >
              Search By Name
            </Card.Header>
            <Card.Body style={{ backgroundColor: "#74a2e3" }}>
              <Form>
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  name="searchByName"
                  value={searchByName}
                  onChange={(e) => setSearchByName(e.target.value)}
                  className="shadow-rounded"
                ></Form.Control>
              </Form>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header
              className="text-center fw-bold text-black"
              style={{ backgroundColor: "#74a2e3" }}
              as="h6"
            >
              Search By Phone
            </Card.Header>
            <Card.Body style={{ backgroundColor: "#74a2e3" }}>
              <Form>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone No."
                  name="searchByPhone"
                  value={searchByPhone}
                  onChange={(e) => setSearchByPhone(e.target.value)}
                  className="shadow-rounded"
                ></Form.Control>
              </Form>
            </Card.Body>
          </Card>
        </CardGroup>

        {/* Table */}
        <Card className="shadow" style={{ backgroundColor: "#74a2e3" }}>
          <Card.Header
            className="text-center text-black p-3 fw-bold"
            style={{ backgroundColor: "#74a2e3" }}
            as="h5"
          >
            Agents List
          </Card.Header>
          <Table
            rounded
            bordered
            hover
            responsive
            style={{ maxHeight: "80vh" }}
          >
            <thead className="text-center">
              <tr>
                <th>No.</th>
                <th>Image</th>
                <th>Agent Name</th>
                <th>NID No.</th>
                <th>Phone No.</th>
                <th>Email</th>
                <th>Agent Commission</th>
                <th>Edit</th>
                <th>Delete</th>
                {/* <th>Print</th> */}
              </tr>
            </thead>
            <tbody className="text-center">
              {isListLoading ? (
                <Loader />
              ) : (
                <>
                  {allAgents.map((agent, index) => (
                    <>
                      <tr key={agent._id} style={{ cursor: "pointer" }}>
                        <td style={{ padding: "0px" }}>{index + 1}</td>
                        <td style={{ padding: "0px" }}>
                          {agent.image ? (
                            <img
                              src={agent.image}
                              className="rounded"
                              style={{ width: "30px", height: "30px" }}
                            />
                          ) : (
                            <img
                              src="https://www.kindpng.com/picc/m/78-785827_user-profile-avatar-login-account 
                          -profile-user-icon-png.png"
                              className="rounded"
                              style={{ width: "30px", height: "30px" }}
                            />
                          )}
                        </td>
                        <td style={{ padding: "0px" }}>{agent.fullName}</td>
                        <td style={{ padding: "0px" }}>{agent.nid}</td>
                        <td style={{ padding: "0px" }}>{agent.phone}</td>
                        <td style={{ padding: "0px" }}>{agent.email}</td>
                        <td style={{ padding: "0px" }}>{agent.commission}</td>

                        {userInfo?.userType === "admin" ? (
                          <>
                            <td style={{ padding: "0px" }}>
                              <LinkContainer to={`/updateAgent/${agent._id}`}>
                                <Button className="btn-sm">
                                  <FaEdit />
                                </Button>
                              </LinkContainer>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <Button
                                className="btn-sm"
                                variant="danger"
                                onClick={() => handleDelete(agent._id)}
                              >
                                <MdDelete />
                              </Button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td style={{ padding: "0px" }}>
                              {/* <LinkContainer to={`/updateAgent/${agent._id}`}> */}
                              <LinkContainer to="">
                                <Button className="btn-sm" disabled>
                                  <FaEdit />
                                </Button>
                              </LinkContainer>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <Button
                                className="btn-sm"
                                variant="danger"
                                // onClick={() => handleDelete(agent._id)}
                                disabled
                              >
                                <MdDelete />
                              </Button>
                            </td>
                          </>
                        )}
                        {/* <td>
                      <Button className="btn-sm">
                        <TiPrinter />
                      </Button>
                    </td> */}
                      </tr>
                    </>
                  ))}
                </>
              )}
            </tbody>
          </Table>
        </Card>
      </Row>
    </Container>
  );
};

export default AgentList;
